module.exports = __webpack_public_path__ + "static/media/7.4c15e1ad.jpg";